import { AddButton } from 'components/AddButton';
import { useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { IVoucherList } from 'types/Voucher';

import { Grid } from '@mui/material';

import { DashboardTitle } from '../../../components/Titles';
import { VoucherList } from './VoucherList';
import { VoucherPagination } from './VoucherPagination';

export const Voucher: React.FC = () => {
  const [vouchers, setVouchers] = useState<IVoucherList>({
    count: 0,
    list: [],
    totalPages: 1,
  });

  let { path } = useRouteMatch();

  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <DashboardTitle title="GESTÃO DE CUPONS" />
      </Grid>
      <Grid item container xs={12} justifyContent="flex-end">
        <AddButton path={`${path}/add`} />
      </Grid>
      <Grid item xs={12}>
        <VoucherPagination
          setLoading={setLoading}
          setVouchers={setVouchers}
          currentPage={page}
          setMaxPage={setMaxPage}
        />
      </Grid>
      <Grid item xs={12}>
        <VoucherList
          loading={loading}
          {...vouchers}
          currentPage={page}
          setPage={setPage}
          maxPage={maxPage}
        />
      </Grid>
    </Grid>
  );
};

